module.exports = __webpack_public_path__ + "static/media/hugo-boss-the-scent-big.27d43cbb.jpg";